import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Outlet, useLocation } from '@tanstack/react-router';

export function Layout() {
  const location = useLocation();
  
  // Check if current path should hide footer
  const shouldHideFooter = 
    // Landing page (exact match)
    location.pathname === '/' ||
    // Reels route pattern: /itineraries/reels/{id}
    /^\/itineraries\/reels\/[^\/]+$/.test(location.pathname) ||
    // Individual itinerary view route pattern: /itineraries/{id} (but not edit routes)
    /^\/itineraries\/[^\/]+$/.test(location.pathname);

  return (
    <div className="flex flex-col min-h-screen bg-muted">
      <Navbar />
      <main className="flex-grow pt-[49px] md:pt-14 pb-[36px] sm:pb-0 md:pl-16">
          <Outlet />
      </main>
      {!shouldHideFooter && <Footer />}
    </div>
  );
}
